var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['lc-loading-indicator', _vm.layout]},_vm._l((_vm.NUM_DOTS),function(n,index){return _c('div',{key:index})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }